import { observable, makeObservable, runInAction } from 'mobx';
import { createOverload } from '../common'
import { cloneDeep } from 'lodash'
import { action } from 'mobx';

export class Result {
  requestCode = -1
  resultCode = -1
  resume: number | undefined
  data = {}
  setData: any
  constructor() {
    this.resume = undefined
    makeObservable(this, {
      resume: observable,
      onResume: action
    })

    this.setData = createOverload()
    this.setData.addImpl('object,number', (data: any, resultCode: number) => {
      this.resultCode = resultCode
      this.data = data
      this.onResume()
    })

    this.setData.addImpl('object', (data: any) => {
      this.data = data
      this.onResume()
    })
    this.setData.addImpl('object,number,number', (data: any, requestCode: number, resultCode: number) => {
      this.requestCode = requestCode
      this.resultCode = resultCode
      this.data = data
      this.onResume()
    })
  }
  onResume() {
    this.resume = Date.now()
  }

  getResult() {
    return cloneDeep(this)
  }
}
